import { useEffect } from "react";
import { useAuth } from "../../contexts/AuthCtx";
import { useAutoScrollOnLoad } from "../../hooks/autoScrollOnLoad";
import ContactListSection from "../../sections/ContactList";
import { Helmet } from "react-helmet";

export default function TermsPage() {

    const authCtx = useAuth();

    useEffect(() => {
        authCtx.set_nav_mode('normal');
    }, []);

    useAutoScrollOnLoad();

    return (
        <>
            <Helmet>
                <title>Terms - Equibre</title>
                <meta name="description" content="Usage terms of our services & this website." />
            </Helmet>
            <section className="page-header-section">
                <div className="inner">
                    <h1>Terms</h1>
                    <p>Last updated: 6 June 2024</p>
                </div>
            </section>
            <section className="privacy-section">
                <div className="inner">
                    <div className="content">
                        <p className="mb-4">
                            By accessing and using equibre ("the Website"), you agree to comply
                            with and be bound by these Terms of Service. If you do not agree
                            with these terms, please refrain from using the Website.
                        </p>
                        <h3 className="mb-2">1. Use of the Website</h3>
                        <p className="mb-4">
                            1.1 <strong>License:</strong> Equibre grants you a limited,
                            non-exclusive, revocable license to access and use the Website in
                            accordance with these Terms.
                        </p>
                        <p className="mb-4">
                            1.2 <strong>Compliance:</strong> You agree to comply with all
                            applicable laws and regulations while using the Website.
                        </p>
                        <h3 className="mb-2">2. User Conduct</h3>
                        <p className="mb-4">
                            2.1 <strong>Prohibited Activities:</strong> You agree not to
                            engage in any of the following activities: - Violating any laws or
                            regulations. - Impersonating others or providing false
                            information. - Attempting to interfere with the proper functioning
                            of the Website. - Exploiting, harming, or harassing others. -
                            Using the Website for any illegal or unauthorized purpose.
                        </p>
                        <p className="mb-4">
                            2.2 <strong>Content Submission:</strong> If the Website allows
                            users to submit content, you are solely responsible for the
                            content you submit, and you warrant that it complies with these
                            Terms.
                        </p>
                        <h3 className="mb-2">3. Intellectual Property</h3>
                        <p className="mb-4">
                            3.1 <strong>Ownership:</strong> All content, features, and
                            functionality on the Website are owned by or licensed to equibre and
                            are protected by intellectual property laws.
                        </p>
                        <p className="mb-4">
                            3.2 <strong>Use of Content:</strong> You may not reproduce,
                            distribute, modify, or otherwise use any content from the Website
                            without the express written consent of equibre.
                        </p>
                        <h3 className="mb-2">4. Privacy</h3>
                        <p className="mb-4">
                            4.1 <strong>Data Collection:</strong> By using the Website, you
                            acknowledge and agree to the terms outlined in the Privacy policy.
                            . The Privacy Policy describes the information we collect and how
                            it is used.
                        </p>
                        <h3 className="mb-2">5. Modifications to the Website</h3>
                        <p className="mb-4">
                            5.1 <strong>Updates:</strong> equibre reserves the right to update,
                            modify, or discontinue the Website, in whole or in part, at any
                            time without notice.
                        </p>
                        <p className="mb-4">
                            5.2 <strong>Termination:</strong> We may terminate or suspend your
                            access to the Website immediately, without prior notice or
                            liability, for any reason, including, but not limited to, breach
                            of these Terms.
                        </p>
                        <h3 className="mb-2">6. Limitation of Liability</h3>
                        <p className="mb-4">
                            6.1 <strong>No Warranty:</strong> The Website is provided "as is"
                            without any warranty of any kind, either expressed or implied.
                        </p>
                        <p className="mb-4">
                            6.2 <strong>Limitation of Liability:</strong> equibre shall not be
                            liable for any direct, indirect, incidental, special,
                            consequential, or exemplary damages, including but not limited to,
                            damages for loss of profits, goodwill, use, data, or other
                            intangible losses.
                        </p>
                        <h3 className="mb-2">7. Governing Law</h3>
                        <p className="mb-4">
                            7.1 <strong>Jurisdiction:</strong> These Terms shall be governed
                            by and construed in accordance with the laws of India, without
                            regard to its conflict of law principles.
                        </p>
                        <h3 className="mb-2">8. Changes to the Terms</h3>
                        <p className="mb-4">
                            8.1 <strong>Updates:</strong> equibre reserves the right to update
                            and modify these Terms of Service at any time. Users will be
                            notified of significant changes through the Website or other
                            communication channels.
                        </p>
                        <h3 className="mb-2">9. Contact Us</h3>
                        <p className="mb-4">
                            If you have any questions or concerns about these Terms of
                            Service, please contact us at{" "}
                            <a href="mailto:support@equibre.com" className="normal-link">
                                support@equibre.com
                            </a>
                            .
                        </p>
                        <p>
                            By accessing and using equibre, you agree to comply with these Terms
                            of Service. Please review them periodically for any updates.
                        </p>
                        <div style={{ width: '100%', height: 80 }}></div>
                    </div>
                </div>
            </section>
            <section className="page-header-section custom-h-no-subtext pt-40">
                <div className="inner">
                    <h1>Disclaimer</h1>
                </div>
            </section>
            <section className="privacy-section">
                <div className="inner">
                    <div className="content">
                        <p className="mb-4">The information, services, products, and materials contained in this site, including, without limitation, text, graphics, and links, are provided on an “as is” basis with no warranty. To the maximum extent permitted by law, Equibre private limited disclaim all representations and warranties, express or implied, with respect to such information, services, products, and materials, including but not limited to warranties of merchantability, fitness for a particular purpose, title, noninfringement, freedom from computer virus, and implied warranties arising from course of dealing or course of performance. In addition, Equibre private limited do not represent or warrant that the information accessible via this web site is accurate, complete or current. Price and availability information is subject to change without notice. Due to the large amount of content and information provided, errors can and will occur. By visiting this web site you agreed that Equibre Private Limited shall be held harmless from all liability and responsibility for any and all errors or omissions in the information provided on this web site. Equibre private limited shall not be required or obligated to honor any price if said price is incorrect or inaccurate, regardless of whether the information was entered by either Equibre private limited.</p>
                        <h3 className="mb-2">Limitation of liability</h3>
                        <p className="mb-4">In no event shall Equibre private limited be liable for any direct, indirect, special, punitive, incidental, exemplary or consequential damages, or any damages whatsoever, even if Equibre private limited has been previously advised of the possibility of such damages, whether in an action under contract, negligence, or any other theory, arising out of or in connection with the use, inability to use, or performance of the information, services, products, and materials available from this site. These limitations shall apply notwithstanding any failure of essential purpose of any limited remedy. Because some jurisdictions do not allow limitations on how long an implied warranty lasts, or the exclusion or limitation of liability for consequential or incidental damages, the above limitations may not apply to you.</p>
                        <h3 className="mb-2">Images, Logos, Trademarks & Copyright</h3>
                        <p className="mb-4">The images, logos, copy and trademarks contained in this site, including but not limited to the text, images, audio or video, may not be used in any manner, or for any purpose, without Equibre private limited express written permission, are believed to be in the public domain or used with permission of the respective trademark or copyright holder. The information and images on this site may not in any way be used in any manner, or for any purpose, without the express written permission, of Equibre private limited or the official holder of the copyright or trademark. Equibre private limited is not responsible for the specific content and/or images contained on this site. Please contact Equibre private limited if you have questions or concerns about the site content.</p>
                        <h3 className="mb-2">Links to external sites</h3>
                        <p className="mb-4">This site may contain links to other web sites on the Internet that are owned and operated by third party vendors and other third parties (hereafter referred to as “External Sites”). You acknowledge that Equibre private limited are not responsible for the availability of, or the content located on or through, any External Site. You should contact the site administrator or Webmaster for those External Sites if you have any concerns regarding such links or the content located on such External Sites.</p>
                        <div style={{ width: '100%', height: 80 }}></div>
                    </div>
                </div>
            </section>
            <ContactListSection />
        </>
    );
}